// extracted by mini-css-extract-plugin
export default {"container":"Specs_container__IvQRO","value":"Specs_value__fE7SM"};